import { render, staticRenderFns } from "./ProductInventoryBox.vue?vue&type=template&id=469fcb54&scoped=true"
import script from "./ProductInventoryBox.vue?vue&type=script&lang=js"
export * from "./ProductInventoryBox.vue?vue&type=script&lang=js"
import style0 from "./ProductInventoryBox.vue?vue&type=style&index=0&id=469fcb54&prod&scoped=true&lang=css"
import style1 from "./ProductInventoryBox.vue?vue&type=style&index=1&id=469fcb54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469fcb54",
  null
  
)

export default component.exports